export default __webpack_public_path__ + "static/media/nisha.3c82aca5.png";